import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { switchMap, tap } from 'rxjs/operators';
import { EmailFrom } from './models/EmailFrom';
import { Employee } from './models/Employee';
import { EmailsService } from './service/emails.service';

@Component({
  selector: 'app-emails-configuration',
  templateUrl: './emails-configuration.component.html',
  styleUrls: ['./emails-configuration.component.less'],
  providers: [EmailsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailsConfigurationComponent implements OnInit {
  employees: Employee[] = [];
  private empList: Employee[] = [];
  emailFroms: EmailFrom[] = [];
  showEmailsFrom = false;
  tempEmpId = 0;
  searchExp = '';
  constructor(
    private emailsService: EmailsService,
    private layoutService: LayoutService,
    private changeDetect: ChangeDetectorRef,
    private message: NzMessageService
  ) {
    layoutService.containerTransparentBGEmitter.emit(true);
  }

  ngOnInit() {
    this.getEmailFroms();
    this.getEmployees().subscribe();
  }

  getEmailFroms() {
    this.emailsService
      .getEmailsFromList()
      .pipe(
        tap((response: EmailFrom[]) => {
          this.emailFroms = response;
          this.changeDetect.detectChanges();
        })
      )
      .subscribe();
  }
  getEmployees() {
    return this.layoutService
      .getListOfRecords(
        9,
        0,
        1,
        20000,
        'USER_CODE',
        'ASC',
        '',
        null,
        [],
        null,
        false
      )
      .pipe(
        tap((response: any) => {
          this.employees = response.table.rowsArray;
          this.empList = JSON.parse(JSON.stringify(response.table.rowsArray));
          this.changeDetect.detectChanges();
        })
      );
  }
  showEmailFromsModal(empId) {
    this.showEmailsFrom = true;
    this.tempEmpId = empId;
  }
  searchForEmp(exp) {
    if (exp == null || exp === '') {
      this.employees = [...this.empList];
    }
    this.employees = this.employees.filter(
      (x) => x.U_NAME.includes(exp) || x.USER_CODE.includes(exp)
    );
    this.changeDetect.detectChanges();
  }
  onChooseRecord(id) {
    this.emailsService
      .assignEmailFrom(this.tempEmpId, id)
      .pipe(
        tap((response) => {
          this.showEmailsFrom = false;
          this.tempEmpId = 0;
          this.message.success(
            this.layoutService.translate('Sender assigned successfully')
          );
          this.changeDetect.detectChanges();
        }),
        switchMap(() => this.getEmployees())
      )
      .subscribe();
  }
}
